module.exports = __webpack_public_path__ + "assets/img/swiper-3-8.a5e1af6f.png";